import {useEffect} from 'react'
import {LazyQueryHookOptions, QueryTuple, useLazyQuery as useLazyQueryOrigin} from '@apollo/client'
import {OperationVariables} from '@apollo/client'
import {useDispatch} from 'react-redux'
import {handleQueryError} from 'libs/graphql'

// oxlint-disable-next-line typescript/no-explicit-any
export const useLazyQuery = <TData = any, TVariables extends OperationVariables = OperationVariables>(
  // oxlint-disable-next-line typescript/no-explicit-any
  query: any,
  options?: LazyQueryHookOptions<TData, TVariables>
): QueryTuple<TData, TVariables> => {
  const dispatch = useDispatch()
  const queryTuple = useLazyQueryOrigin<TData, TVariables>(query, options)
  const [, queryResult] = queryTuple

  useEffect(() => {
    if (queryResult.error) {
      handleQueryError(queryResult.error, dispatch)
    }
  }, [dispatch, queryResult.error])

  return queryTuple
}
